import {BookingConfirmationPresenter} from "./bookingConfirmationPresenter";
import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class BookingConfirmationView extends ViewBase implements IView {

    public _presenter: BookingConfirmationPresenter;
    
    constructor(viewName:string, router:Router, dependencyContainer: ParcelDependencyContainer) {
        super(viewName, router, dependencyContainer);
    }


    public set displayName(displayName){
        this.setTextById('display-name', displayName);
    }
    
    public set handle(handle){
        this.setTextById('handle-name', handle);
    }


    public setPresenter(presenter: BookingConfirmationPresenter) {
        this._presenter = presenter;
    }

    public render(): void {
    }
    
    public showLoggedIn(value: boolean) {
        this.setElementVisibility('#not-logged-in', !value);
        this.setElementVisibility('#logged-in', value);
    }
    
}